import * as React from 'react';

var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgRecentGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.457,
    height: 18,
    viewBox: "0 0 18.457 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".RecentGrey_svg__recent-gray_b{fill:#08123b}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    className: "RecentGrey_svg__recent-gray_b",
    d: "M9.45 0A8.882 8.882 0 001.8 4.392V2.7a.9.9 0 10-1.8 0v3.6a.9.9 0 00.9.9h4.05a.9.9 0 000-1.8H3.294A7.082 7.082 0 019.45 1.8a7.2 7.2 0 11-6.776 9.6.9.9 0 00-1.7.594A9 9 0 109.45 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "RecentGrey_svg__recent-gray_b",
    d: "M12.824 12.6a.9.9 0 01-.54-.18l-3.6-2.7a.9.9 0 01-.36-.72V5.4a.9.9 0 111.8 0v3.15l3.24 2.43a.9.9 0 01-.54 1.62z"
  }))));
}

export { SvgRecentGrey as ReactComponent };
//# sourceMappingURL=RecentGrey.svg.js.map
